import { render, staticRenderFns } from "./ib-form-array.vue?vue&type=template&id=0be6d0c9&lang=pug&"
import script from "./ib-form-array.vue?vue&type=script&lang=js&"
export * from "./ib-form-array.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0be6d0c9')) {
      api.createRecord('0be6d0c9', component.options)
    } else {
      api.reload('0be6d0c9', component.options)
    }
    module.hot.accept("./ib-form-array.vue?vue&type=template&id=0be6d0c9&lang=pug&", function () {
      api.rerender('0be6d0c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/ib-form-array.vue"
export default component.exports